module.exports = __webpack_public_path__ + "img/5_57.6c6c7ac7.png";